import { render, staticRenderFns } from "./PastInformation.vue?vue&type=template&id=a1287606"
import script from "./PastInformation.vue?vue&type=script&lang=js"
export * from "./PastInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports